import { Image } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import IMAGES from '../../const/images';

const Logo: FC = () => {
    const navigate = useNavigate();
    const styles = {
        logo: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '12px 0',
            margin: '0 auto',
            width: '100%',
        },
    };

    return (
        <div style={styles.logo}>
            <Image
                src={IMAGES.logo.horizontal}
                alt="logo-fleets"
                preview={false}
                onClick={() => navigate('/')}
                width="65%"
            />
        </div>
    );
};

export { Logo };
